<script setup lang="ts">
import type {
	StandardSliderArrowEmits,
	StandardSliderArrowProps
} from './index';

import { cn } from '@/utils';

const props = withDefaults(defineProps<StandardSliderArrowProps>(), {
	disabled: false,
	isVisible: false
});

const emit = defineEmits<StandardSliderArrowEmits>();

function handleClick() {
	if (!props.disabled) {
		emit('click');
	}
}
</script>

<template>
	<button
		v-bind="$attrs"
		:disabled="disabled"
		:class="
			cn(
				'absolute z-10 flex size-8 md:size-10 lg:size-12 items-center justify-center rounded-full bg-white shadow-[0px_1px_3px_1px_rgba(0,0,0,0.15)]',
				'top-1/2 -translate-y-1/2 right-4 md:right-5 lg:right-12',
				'hover:bg-gray-50 active:scale-95',
				'disabled:cursor-not-allowed disabled:opacity-50',
				isVisible ? 'animate-arrow-enter-next' : 'animate-arrow-exit-next',
				$attrs.class as string
			)
		"
		@click="handleClick"
	>
		<IconMaterialSymbolsLightChevronRight
			class="size-8 font-semibold text-primary"
		/>
		<span class="sr-only">Next</span>
	</button>
</template>
